"use strict";

var _interopRequireDefault = require("/var/jenkins_home/workspace/sihong_test_front_mall/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _interopRequireWildcard2 = _interopRequireDefault(require("/var/jenkins_home/workspace/sihong_test_front_mall/node_modules/@babel/runtime-corejs2/helpers/interopRequireWildcard.js"));
var _createForOfIteratorHelper2 = _interopRequireDefault(require("/var/jenkins_home/workspace/sihong_test_front_mall/node_modules/@babel/runtime-corejs2/helpers/createForOfIteratorHelper.js"));
var _coupon = require("@/api/coupon");
var _Pagination = _interopRequireDefault(require("@/components/Pagination"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Secondary package based on el-pagination

var defaultTypeOptions = [{
  label: '通用领券',
  value: 0
}, {
  label: '注册赠券',
  value: 1
}, {
  label: '兑换码',
  value: 2
}];
var defaultStatusOptions = [{
  label: '未生效',
  value: 0
}, {
  label: '正常',
  value: 1
}, {
  label: '已过期',
  value: 2
}];
var _default = exports.default = {
  name: 'ProCoupon',
  components: {
    Pagination: _Pagination.default
  },
  filters: {
    formatType: function formatType(type) {
      for (var i = 0; i < defaultTypeOptions.length; i++) {
        if (type === defaultTypeOptions[i].value) {
          return defaultTypeOptions[i].label;
        }
      }
      return '';
    },
    formatGoodsType: function formatGoodsType(goodsType) {
      if (goodsType === 0) {
        return '全场通用';
      } else if (goodsType === 1) {
        return '指定分类';
      } else {
        return '指定商品';
      }
    },
    formatStatus: function formatStatus(status) {
      if (status === 0) {
        return '未生效';
      } else if (status === 1) {
        return '正常';
      } else {
        return '已过期';
      }
    }
  },
  data: function data() {
    var _this = this;
    return {
      pickerOptions: {
        disabledDate: function disabledDate(time) {
          if (_this.dataForm.endTime) {
            return time.getTime() > new Date(_this.dataForm.endTime).getTime() || time.getTime() < Date.now() - 8.64e7;
          } else {
            //还没有选择结束时间的时候，让他只能选择今天之后的时间包括今天
            return time.getTime() < Date.now() - 8.64e7;
          }
        }
      },
      pickerOptions2: {
        disabledDate: function disabledDate(time) {
          if (_this.dataForm.startTime) {
            return time.getTime() <= new Date(_this.dataForm.startTime).getTime();
          }
          return time.getTime() < Date.now() - 8.64e7;
        }
      },
      couponCode: '11111',
      viewVisible: false,
      typeOptions: Object.assign({}, defaultTypeOptions),
      statusOptions: Object.assign({}, defaultStatusOptions),
      list: [],
      total: 0,
      listLoading: true,
      listQuery: {
        page: 1,
        limit: 20,
        name: undefined,
        // type: undefined,
        status: undefined,
        sort: 'add_time',
        order: 'desc'
      },
      dataForm: {
        id: undefined,
        name: undefined,
        desc: undefined,
        tag: undefined,
        code: undefined,
        total: 0,
        discount: 0,
        min: 0,
        limit: 1,
        type: 2,
        status: 0,
        goodsType: 0,
        goodsValue: [],
        timeType: 0,
        days: 0,
        startTime: null,
        endTime: null,
        siteType: 0,
        policy: 0,
        amount: null,
        restCount: 0
      },
      dialogFormVisible: false,
      dialogStatus: '',
      textMap: {
        update: '编辑',
        create: '创建'
      },
      rules: {
        name: [{
          required: true,
          message: '优惠券标题不能为空',
          trigger: 'blur'
        }],
        amount: [{
          required: true,
          message: '优惠策略不能为空',
          trigger: 'blur'
        }],
        code: [
        // {required:false,message:'兑换码不能为空',trigger: 'blur'}
        {
          required: false,
          validator: function validator(rule, value, callback) {
            if (value) {
              // 检查输入长度是否大于 8 位
              if (value.length > 8) {
                _this.dataForm.code = value.slice(0, 8);
                callback(new Error('限8位以内字母、数字或符号，已自动截断'));
                return;
              }
              // 检查输入长度是否在 1 到 8 位之间
              if (value.length > 0 && value.length < 8) {
                callback(new Error('输入不可少于8位'));
                return;
              }
              // 检查是否包含非法字符
              var pattern = /^[a-zA-Z0-9!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+$/;
              if (!pattern.test(value)) {
                callback(new Error('不可输入非法字符或空格，仅限字母、数字或符号'));
                return;
              }
            }
            callback();
          },
          trigger: 'blur'
        }]
      },
      downloadLoading: false
    };
  },
  created: function created() {
    this.getList();
  },
  computed: {
    disabledStates: function disabledStates() {
      var _this2 = this;
      return this.list.map(function (row) {
        return _this2.isEffectTime(row);
      });
    },
    // 剩余优惠券
    restCount: function restCount() {
      if (this.dataForm.total != 0) {
        return this.dataForm.restCount + this.dataForm.total;
      }
    }
  },
  methods: {
    changeNum: function changeNum() {},
    isEffectTime: function isEffectTime(row) {
      var effectTime = new Date(row.effectTime);
      var currentTime = new Date();
      return currentTime >= effectTime;
    },
    changeStartTime: function changeStartTime(val) {
      console.log(val);
    },
    changeendTime: function changeendTime(val) {
      console.log('val', val);
    },
    onCancel: function onCancel() {
      this.listQuery.name = undefined;
      this.listQuery.status = undefined;
      this.getList();
    },
    onCopyCode: function onCopyCode() {
      var _this3 = this;
      navigator.clipboard.writeText(this.couponCode).then(function () {
        _this3.$message.success('兑换码复制成功');
      });
    },
    handleView: function handleView(row) {
      if (!row.code) return this.$message.warning('暂无兑换码');
      this.viewVisible = true;
      this.couponCode = row.code;
    },
    getList: function getList() {
      var _this4 = this;
      this.listLoading = true;
      (0, _coupon.listCoupon)(this.listQuery).then(function (response) {
        _this4.list = response.data.data.list;
        _this4.total = response.data.data.total;
        _this4.listLoading = false;
      }).catch(function () {
        _this4.list = [];
        _this4.total = 0;
        _this4.listLoading = false;
      });
    },
    handleFilter: function handleFilter() {
      this.listQuery.page = 1;
      this.getList();
    },
    resetForm: function resetForm() {
      this.dataForm = {
        id: undefined,
        name: undefined,
        desc: undefined,
        tag: undefined,
        total: 0,
        discount: 0,
        min: 0,
        limit: 1,
        type: 2,
        status: 0,
        goodsType: 0,
        goodsValue: [],
        timeType: 0,
        days: 0,
        startTime: null,
        endTime: null,
        siteType: 0,
        policy: 0,
        amount: null
      };
    },
    handleCreate: function handleCreate() {
      var _this5 = this;
      this.resetForm();
      this.dialogStatus = 'create';
      this.dialogFormVisible = true;
      this.$nextTick(function () {
        _this5.$refs['dataForm'].clearValidate();
      });
    },
    createData: function createData() {
      var _this6 = this;
      this.$refs['dataForm'].validate(function (valid) {
        if (valid) {
          (0, _coupon.createCoupon)(_this6.dataForm).then(function (response) {
            _this6.list.unshift(response.data.data);
            _this6.dialogFormVisible = false;
            _this6.$notify.success({
              title: '成功',
              message: '创建优惠券成功'
            });
            _this6.getList();
          }).catch(function (response) {
            _this6.$notify.error({
              title: '失败',
              message: response.data.errmsg
            });
          });
        }
      });
    },
    handleUpdate: function handleUpdate(row) {
      var _this7 = this;
      this.dataForm = Object.assign({}, row);
      this.dialogStatus = 'update';
      this.dialogFormVisible = true;
      this.$nextTick(function () {
        if (_this7.dataForm.days === 0) {
          _this7.dataForm.daysType = 1;
        } else {
          _this7.dataForm.daysType = 0;
        }
        _this7.$refs['dataForm'].clearValidate();
      });
    },
    updateData: function updateData() {
      var _this8 = this;
      this.$refs['dataForm'].validate(function (valid) {
        if (valid) {
          (0, _coupon.updateCoupon)(_this8.dataForm).then(function () {
            var _iterator = (0, _createForOfIteratorHelper2.default)(_this8.list),
              _step;
            try {
              for (_iterator.s(); !(_step = _iterator.n()).done;) {
                var v = _step.value;
                if (v.id === _this8.dataForm.id) {
                  var index = _this8.list.indexOf(v);
                  _this8.list.splice(index, 1, _this8.dataForm);
                  break;
                }
              }
            } catch (err) {
              _iterator.e(err);
            } finally {
              _iterator.f();
            }
            _this8.dialogFormVisible = false;
            _this8.$notify.success({
              title: '成功',
              message: '更新优惠券成功'
            });
            _this8.getList();
          }).catch(function (response) {
            _this8.$notify.error({
              title: '失败',
              message: response.data.errmsg
            });
          });
        }
      });
    },
    handleDelete: function handleDelete(row) {
      var _this9 = this;
      this.$confirm('是否要进行删除操作?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        (0, _coupon.deleteCoupon)({
          couponId: row.id
        }).then(function (response) {
          _this9.$notify.success({
            title: '成功',
            message: '删除优惠券成功'
          });
          var index = _this9.list.indexOf(row);
          _this9.list.splice(index, 1);
        }).catch(function (response) {
          _this9.$notify.error({
            title: '失败',
            message: response.data.errmsg
          });
        });
      });
    },
    handleDetail: function handleDetail(row) {
      this.$router.push({
        path: '/promotion/couponDetail',
        query: {
          id: row.id
        }
      });
    },
    handleDownload: function handleDownload() {
      var _this0 = this;
      this.downloadLoading = true;
      Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require('@/vendor/Export2Excel'));
      }).then(function (excel) {
        var tHeader = ['优惠券ID', '名称', '内容', '标签', '最低消费', '减免金额', '每人限领', '优惠券数量'];
        var filterVal = ['id', 'name', 'desc', 'tag', 'min', 'discount', 'limit', 'total'];
        excel.export_json_to_excel2(tHeader, _this0.list, filterVal, '优惠券信息');
        _this0.downloadLoading = false;
      });
    }
  }
};